<template>
  <div class="carousel-interface" :class="{
    'carousel-interface--vertical': vertical,
    'carousel-interface--hero-horizontal': heroHorizontal
  }">
    <outline-button
      noBorder
      iconOnly
      :buttonIcon="buttonIcons.prev"
      @click="handleClick('prev')"
      v-if="heroHorizontal"
    />
    <div class="carousel-interface__count">
      <span class="carousel-interface__count__number">
        {{indexString}}
      </span>
      <div class="carousel-interface__count__progress">
        <span
          class="carousel-interface__count__progress__background"
          :style="percentageStyle"
        />
      </div>
      <span class="carousel-interface__count__number">
        {{progressDestinationString}}
      </span>
    </div>
    <outline-button
      noBorder
      iconOnly
      :buttonIcon="buttonIcons.next"
      @click="handleClick('next')"
      v-if="heroHorizontal"
    />
    <div class="carousel-interface__buttons" v-if="!heroHorizontal">
      <outline-button
        noBorder
        iconOnly
        :buttonIcon="buttonIcons.prev"
        @click="handleClick('prev')"
      />
      <outline-button
        noBorder
        iconOnly
        :buttonIcon="buttonIcons.next"
        @click="handleClick('next')"
      />
    </div>
  </div>
</template>

<script>
// base for carousel interface used in hero / prize sections
import CarouselInterface from './../mixins/carousel-interface';
import OutlineButton from './rb-button-outline';

export default {
  name: 'carousel-interface',
  mixins: [CarouselInterface],
  components: {
    OutlineButton
  },
};
</script>

<style lang="scss">
.carousel-interface {
  display: flex;
  justify-content: space-between;
  &__count {
    display: flex;
    align-items: center;
    &__number {
      font-family: $font-family-carousel-indicator-labels;
      font-size: $size-text-carousel-indicator-labels;
      line-height: $size-lineheight-carousel-indicator-labels;
      color: $color-carousel-indicator-text;
      display: inline-block;
      text-align:  center;
      width: $size-width-carousel-indicator-number-base;
    }
    &__progress {
      position: relative;
      height: $size-height-progress-indicator;
      width: $size-width-progress-indicator;
      background-color: $color-text-base;
      margin: 0 $size-margin-progress-indicator;
      overflow: hidden;
      &__background {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: $color-base-ninja-yellow-base;
        transform: translateX(-100%);
      }
    }
  }
  .rb-button-outline--icon-only {
    height: $size-height-progress-indicator-buttons;
  }
  &--hero-horizontal {
    .carousel-interface {
      &__count {
        width: 100%;
        margin: 0 $size-margin-carousel-indicator-count;

        &__progress {
          flex: 1 1 auto;
        }
      }
    }
  }
  &__buttons {
    margin-right: $size-margin-prize-carousel-buttons;
  }
  &--vertical {
    flex-direction: column;
    .carousel-interface {
      &__count {
        flex-direction: column;
        &__progress {
          width: $size-height-progress-indicator;
          height: $size-width-progress-indicator;
          margin: $size-margin-progress-indicator 0;
        }
      }
      &__buttons {
        margin-top: $size-margin-top-hero-carousel-buttons;
        margin-right: 0rem;
        display: flex;
        flex-direction: column;
      }
    }
  }
  .rb-button-outline {
    transition: transform 300ms ease;
    &:hover {
      transform: scale(1.3);
    }
  }
}
</style>
